import { z } from "zod";

export const getVehiclesByCompanyPayloadSchema = z.object({
  companyUuid: z.uuid(),
});

export type GetVehiclesByCompanyPayload = z.infer<
  typeof getVehiclesByCompanyPayloadSchema
>;
